import { createContext, useContext } from 'react';

/**
 * Onde um seletor que abre por cima (calendário, lista de opções) está: numa
 * página ou dentro de um `Modal` (30/10/2026).
 *
 * Dentro do modal o seletor precisa do `z-50` e do `Popover` modal; numa
 * página, do `z-10`, abaixo da faixa do topo. Cada campo recebia isso por
 * `layer`, e esquecê-lo não dava erro: o calendário do "A partir de" abria
 * ATRÁS da ficha do consultor, sem como clicar. Eram 86 campos de data e 29
 * declaravam a camada. Agora o `Modal` diz onde está, e o campo herda; `layer`
 * explícito continua vencendo.
 */
export type Layer = 'painel' | 'modal';

export const LayerContext = createContext<Layer>('painel');

/** A camada declarada no campo, ou a de quem o contém. */
export function useLayer(explicit?: Layer): Layer {
  const inherited = useContext(LayerContext);
  return explicit ?? inherited;
}
